import { render, staticRenderFns } from "./font-size-handler.vue?vue&type=template&id=8b20fd98&scoped=true&"
import script from "./font-size-handler.vue?vue&type=script&lang=js&"
export * from "./font-size-handler.vue?vue&type=script&lang=js&"
import style0 from "./font-size-handler.vue?vue&type=style&index=0&id=8b20fd98&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b20fd98",
  null
  
)

export default component.exports